// Maximum hourly rate (in cents) an expert may set. Mirrors the API cap in
// api/profile/service/profile_service.go (maxBillRate) — the server is
// authoritative; this value is advisory UX. The Currency input caps entry at 6
// digits ($9,999.99), so raising this past that also requires bumping Currency's
// maxlength. ENG-5267.
export const MAX_BILL_RATE_CENTS = 200_000;

const MAX_BILL_RATE_LABEL = `$${(MAX_BILL_RATE_CENTS / 100).toLocaleString('en-US')}`;

// Validates the bill_rate form field (in cents). Returns an error message when
// the rate exceeds the cap, otherwise undefined. "Required" is handled by the
// forms themselves.
export function billRateError(billRate: number | undefined): string | undefined {
  if (billRate !== undefined && billRate > MAX_BILL_RATE_CENTS) {
    return `Hourly rate can't be higher than ${MAX_BILL_RATE_LABEL}`;
  }
  return undefined;
}
